import { MediaWidget } from '../types'

interface Props {
  instance: MediaWidget
}

export const DashboardDefaultMedia = ({ instance }: Props) => {
  return <embed src={instance.media_url} width="100%" height="375" />
}
